import React, { useMemo } from "react";
import CustomisationPopup from "../../../components/customisationPopup";
import CustomisationModal from "../../../mobileComponents/customisationModal";
import { transformModifierAppliedFreeItem } from "./utils";

interface IModifierPopupProps {
  modifierItem: any;
  updateFreeItemCart(newFreeItemCart: any[]): void;
  freeItemCart: any[];
  toggleUserClosePromotionPopup(updatedState: boolean): void;
  availablePromotions: any[];
}

const ModifierPopup = ({
  modifierItem,
  updateFreeItemCart,
  freeItemCart,
  toggleUserClosePromotionPopup,
}: IModifierPopupProps) => {
  const modifyFreeItemWithModifier = (
    e: React.MouseEvent<HTMLButtonElement>,
    item: any
  ) => {
    const updatedItem = transformModifierAppliedFreeItem(item);
    const updatedFreeItemCart = freeItemCart.map((cartItem) =>
      updatedItem.id === cartItem.id ? updatedItem : cartItem
    );
    updateFreeItemCart(updatedFreeItemCart);
    toggleUserClosePromotionPopup(false)
  };

  const itemModiferFreeDetails = useMemo(() => {
    const isFreeItem = true; //always true
    const isFreeModifier = modifierItem.promotionIncludesModifier || false;
    return {
      isFreeItem,
      isFreeModifier,
    };
  }, [modifierItem]);

  const PopupComponent =
    window.screen.width >= 768 ? CustomisationPopup : CustomisationModal;

  return (
    <PopupComponent
      onClose={() => {}} // prevent modal closing when user click on modal backdrop
      modifierItem={modifierItem}
      onModifierAdd={modifyFreeItemWithModifier}
      isFreeItem={itemModiferFreeDetails.isFreeItem}
      isModifiersFree={itemModiferFreeDetails.isFreeModifier}
    />
  );
};

export default ModifierPopup;
